import firebase from "firebase";
const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyBT2ZvXK3Gb8gaSe9hRYFHebVt8h-2MZyE",
  authDomain: "peanuts-qr-registration.firebaseapp.com",
  databaseURL: "https://peanuts-qr-registration.firebaseio.com",
  projectId: "peanuts-qr-registration",
  storageBucket: "peanuts-qr-registration.appspot.com",
  messagingSenderId: "974983116192",
  appId: "1:974983116192:web:3a2a06224afc3ced38e0c5"
});

const db = firebaseApp.firestore();

export { db };

  
